import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 45,
  label: "申请人专利类型分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{
      name: "applicantNewName",
      label: "申请人",
      table: "patent_applicant",
      limit: 10,
      needTotal: true
    }],
    colDims: [{ name: "patentType", label: "专利类型", limit: 10, needTotal: true }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "申请人专利类型分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false
  }
};
